export default __webpack_public_path__ + "static/media/ic_tonga.3b0d1b02.svg";